var _desc, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 16C32 24.83 24.83 32 16 32C7.16 32 0 24.83 0 16C0 7.16 7.16 0 16 0C24.83 0 32 7.16 32 16Z",
    fill: "#26A17B",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.92 17.38L17.92 17.38C17.81 17.38 17.24 17.42 15.98 17.42C14.97 17.42 14.25 17.39 14 17.38L14 17.38C10.12 17.21 7.21 16.53 7.21 15.72C7.21 14.91 10.12 14.24 14 14.06L14 16.71C14.26 16.72 14.99 16.77 15.99 16.77C17.2 16.77 17.8 16.72 17.92 16.71L17.92 14.06C21.8 14.24 24.69 14.91 24.69 15.72C24.69 16.53 21.8 17.21 17.92 17.38ZM17.92 13.79L17.92 11.42L23.33 11.42L23.33 7.81L8.59 7.81L8.59 11.42L14 11.42L14 13.79C9.6 13.99 6.3 14.86 6.3 15.91C6.3 16.95 9.6 17.82 14 18.02L14 25.61L17.92 25.61L17.92 18.02C22.31 17.82 25.61 16.95 25.61 15.91C25.61 14.86 22.31 13.99 17.92 13.79Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTezer);
export default __webpack_public_path__ + "static/media/tezer.4e114aa57d21c612e1dd814c21608127.svg";
export { ForwardRef as ReactComponent };